import { genView } from "./Colleges.tsx";

export default genView("jerseyNumbers");
